import type { DateTime } from 'luxon';

type SortableEvent = {
  isAllDay: boolean;
  startDate: DateTime;
};

export const sortByStartDate = <T extends SortableEvent>(events: T[]): T[] =>
  [...events].sort((a, b) => {
    const diff = a.startDate.toMillis() - b.startDate.toMillis();
    if (diff !== 0) return diff;
    return Number(b.isAllDay) - Number(a.isAllDay);
  });
